<template>
  <div class="login-page">
    <sectionTitle :titleObj="titleObj"></sectionTitle>
    <div class="login-container">
      <div class="login-header">
        <p>欢迎来到攀枝花东区社会工作协会平台</p>
      </div>
      <el-form
        ref="loginForm"
        :model="formData"
        :rules="rules"
        label-width="100px"
        class="login-form"
        label-position="left"
        @submit.native.prevent="handleLogin"
      >
        <el-form-item prop="username" label="账号">
          <el-input
            v-model="formData.username"
            placeholder="请输入身份证号"
            size="large"
          />
        </el-form-item>
        <el-form-item prop="password" label="登录密码">
          <el-input
            v-model="formData.password"
            type="password"
            placeholder="请输入密码"
            size="large"
            show-password
          />
        </el-form-item>
        <!-- @keyup.enter.native="handleLogin" -->
        <el-form-item label="图片验证码" prop="code">
          <div class="captcha-box">
            <el-input
              v-model="formData.code"
              placeholder="请输入图片验证码"
              size="large"
              maxlength="6"
            />
            <el-tooltip
              content="点击重新获取验证码"
              placement="right"
              effect="light"
            >
              <el-image
                class="imageCode"
                :src="codeImage"
                @click="getImageCode"
              ></el-image>
            </el-tooltip>

            <!-- <canvas 
                ref="captchaCanvas" 
                class="captcha-canvas"
                @click="refreshCaptcha"
                title="点击刷新验证码"
                ></canvas> -->
          </div>
        </el-form-item>

        <el-form-item label-width="0">
          <div class="flex button-box">
            <el-button
              class="back-button"
              :loading="loading"
              size="large"
              @click="backHome"
            >
              取消并返回首页
            </el-button>
            <el-button
              type="primary"
              class="login-button"
              :loading="loading"
              native-type="submit"
              size="large"
            >
              立即登录
            </el-button>
          </div>
        </el-form-item>
      </el-form>
      <div class="login-footer">
        <router-link to="" class="forget-link">忘记密码</router-link>
        <router-link to="/register/agreement" class="register-link"
          >立即注册</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import sectionTitle from "@/components/sectionTitle.vue";
import { login, getCaptcha, getInfo } from "@/api/api.js";
import { decrypt, encrypt } from "@/utils/jsencrypt";
import { setToken, setLoginStatus, setUserInfo } from "@/utils/auth";

export default {
  name: "Login",
  components: {
    sectionTitle,
  },
  data() {
    return {
      value: "",
      titleObj: {
        title: "登录",
        subtitle: "Login",
      },
      formData: {
        username: "",
        password: "",
        code: "",
        captchaKey: "",
      },
      captchaCode: "",
      rules: {
        username: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { validator: this.validateIdCard, trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, message: "密码长度不能少于6位", trigger: "blur" },
        ],
        code: [
          { required: true, message: "请输入图片验证码", trigger: "blur" },
          //   { validator: this.validateCaptcha, trigger: 'blur' }
        ],
      },
      loading: false,
      redirect: null,
      codeImage: "",
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {
    // this.generateCaptcha()
    this.getImageCode();
    // this.getRememberedUser()
  },
  methods: {
    //获取图片验证码
    getImageCode() {
      getCaptcha().then((res) => {
        if (res.data.code == 200) {
          this.codeImage = res.data.data.imageBase64;
          this.formData.captchaKey = res.data.data.captchaKey;
        }
      });
    },
    getRememberedUser() {
      const rememberedUser = localStorage.getItem("rememberedUser");
      if (rememberedUser) {
        const user = JSON.parse(rememberedUser);
        this.formData.username = user.username;
        this.formData.rememberMe = user.rememberMe;
      }
    },
    //刷新验证码
    refreshCaptcha() {
      //   this.generateCaptcha()
      // this.formData.captcha = ''
      this.getImageCode();
      this.formData.code = "";
    },
    //登录
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;

          const loginParams = {
            username: this.formData.username,
            password: encrypt(this.formData.password),
            captchaKey: this.formData.captchaKey,
            code: this.formData.code,
          };

          login(loginParams)
            .then((res) => {
              this.loading = false;
              // console.log(res)
              if (res.data.code === 200) {
                this.$message.success("登录成功");
                
                // 设置登录状态（sessionStorage，关闭浏览器自动清除）
                setLoginStatus(true);
                
                // 设置 Token（会话 cookie，关闭浏览器自动清除）
                if (res.data.data) {
                  setToken(res.data.data);
                }
                
                // 获取用户信息
                this.getInfoData();
                
                this.$router
                  .push({ path: this.redirect || "/index" })
                  .catch(() => {});
                window.dispatchEvent(new Event("loginStatusChanged"));
              } else {
                this.$message.error(
                  res.data.msg || "登录失败，请检查用户名和密码"
                );
                this.refreshCaptcha();
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message.error(
                (error.data && error.data.msg) || "登录失败，请检查网络连接"
              );
              this.refreshCaptcha();
            });
        } else {
          this.$message.warning("请填写完整的登录信息");
          return false;
        }
      });
    },
    //获取用户信息
    getInfoData() {
      getInfo().then((res) => {
        if (res.data.code == 200 && res.data.data) {
          // 使用 sessionStorage 存储用户信息
          setUserInfo(res.data.data);
          window.dispatchEvent(new Event("loginStatusChanged"));
        }
      });
    },
    backHome() {
      this.$router.replace({ path: this.redirect || "/index" });
    },
    validatePhone(rule, value, callback) {
      if (!value) {
        callback(new Error("请输入手机号"));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    },
    validateCaptcha(rule, value, callback) {
      if (!value) {
        callback(new Error("请输入图片验证码"));
      } else if (value.toLowerCase() !== this.captchaCode.toLowerCase()) {
        callback(new Error("验证码错误"));
        this.refreshCaptcha();
      } else {
        callback();
      }
    },
    generateCaptcha() {
      const canvas = this.$refs.captchaCanvas;
      if (!canvas) return;

      const ctx = canvas.getContext("2d");
      canvas.width = 130;
      canvas.height = 40;

      const chars = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789";
      let code = "";

      ctx.fillStyle = "#f0f0f0";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      for (let i = 0; i < 4; i++) {
        const char = chars[Math.floor(Math.random() * chars.length)];
        code += char;

        ctx.save();
        ctx.translate(30 * i + 20, 25);
        ctx.rotate((Math.random() - 0.5) * 0.4);
        ctx.font = "bold 24px Arial";
        ctx.fillStyle = this.getRandomColor();
        ctx.fillText(char, 0, 0);
        ctx.restore();
      }

      for (let i = 0; i < 6; i++) {
        ctx.beginPath();
        ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.strokeStyle = this.getRandomColor(150, 200);
        ctx.lineWidth = 1;
        ctx.stroke();
      }

      for (let i = 0; i < 30; i++) {
        ctx.beginPath();
        ctx.arc(
          Math.random() * canvas.width,
          Math.random() * canvas.height,
          1,
          0,
          2 * Math.PI
        );
        ctx.fillStyle = this.getRandomColor(150, 200);
        ctx.fill();
      }

      this.captchaCode = code;
    },
    getRandomColor(min = 50, max = 150) {
      const r = Math.floor(Math.random() * (max - min) + min);
      const g = Math.floor(Math.random() * (max - min) + min);
      const b = Math.floor(Math.random() * (max - min) + min);
      return `rgb(${r},${g},${b})`;
    },
    validateIdCard(rule, value, callback) {
      if (!value) {
        callback(new Error("请输入身份证号"));
        return;
      }
      // 15位纯数字 或 18位（前17位数字，第18位为数字或X/x）
      const idCardRegex = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;
      if (idCardRegex.test(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的身份证号"));
      }
    },
  },
};
</script>

<style scoped lang="less">
.login-page {
  min-height: 100vh;
  background: #fff;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-container {
  width: 100%;
  max-width: 400px;
  background: white;
  /* border-radius: 10px; */
  /* padding: 40px 30px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2); */
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.login-header h2 {
  font-size: 24px;
  color: #333;
  margin: 0 0 10px 0;
  font-weight: bold;
}

.login-header p {
  font-size: 16px;
  color: #999;
  margin: 0;
}

.login-form {
  margin-bottom: 20px;
}

.login-form .el-form-item {
  margin-bottom: 25px;
}

.captcha-box {
  display: flex;
  align-items: center;
  gap: 10px;
  .imageCode {
    width: 120px;
    height: 100%;
  }
}

.captcha-box .el-input {
  flex: 1;
}

.captcha-canvas {
  width: 130px;
  height: 40px;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  transition: all 0.3s;
}

.button-box {
  margin-top: 12px;
  .back-button {
    flex: 1;
    height: 42px;
    text-align: center;
    background: #f0f0f0;
    border-radius: 8px;
    font-size: 16px;
    color: #999999;
    border: none;
  }
}
.login-button {
  width: 240px;
  height: 42px;
  background: #ed9d26;
  border-radius: 8px;
  font-size: 16px;
  color: #ffffff;
  border: none;
}

.login-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 20px;
  //   padding-top: 20px;
  //   border-top: 1px solid #eee;
}

.login-footer a {
  color: #2c99ff;
  text-decoration: underline;
  font-size: 14px;
  // transition: color 0.3s;
}

.login-footer a:hover {
  color: #667eea;
}

.register-link,
.forget-link {
  padding: 5px 10px;
  border-radius: 4px;
}

// .register-link:hover,
// .forget-link:hover {
//   background-color: #f5f5f5;
// }
::v-deep .el-button:focus,
.el-button:hover {
  border: 0;
}
</style>
